export const counter = {
  cartsCount: 'Total des brouillons de commande',
  cartsValue: 'Valeur des brouillons de commande',
  quotesCount: 'Total des soumissions ouvertes',
  quotesValue: 'Valeur des soumissions ouvertes',
};
export const customer = {
  context: {
    set: 'Le contexte client a été défini avec succès.',
    remove: 'Le contexte client a été supprimé avec succès.',
    required: 'Veuillez sélectionner une division pour continuer.',
    changeCustomerMessage: 'Voulez-vous changer de client?',
    changeCustomerLabel: 'Changer de client?',
  },
  label: {
    heading: 'Recherche de clients',
    name: 'Nom du compte',
    number: 'Numéro de compte',
    street: 'Rue',
    country: 'Pays',
    state: 'État/Province',
    stateLine1: 'État/',
    stateLine2: 'Province',
    selectState: 'Sélectionner l\'état/la province',
    city: 'Ville',
    zipCode: 'Code postal',
    phoneNo: 'N° de téléphone',
    noCustomerFound: 'Aucun client trouvé',
    downloadCustomerList: 'Liste des clients',
    salesArea: 'Division',
    selectSalesArea: 'Sélectionner une division',
    selectSalesAreaFirst: 'Veuillez sélectionner une division pour continuer.',
  },
  recentCustomer: {
    heading: 'Clients récents',
    name: 'Nom',
    state: 'État/Province',
    city: 'Ville',
  },
};
export const quicklinks = {
  label: {
    heading: 'Liens rapides',
  },
};

export const knbrHome = { counter, customer, quicklinks };
